import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TipView } from '../community-format';

/** A tip shown as an event, not as a chat bubble. The gold coin is a fixed status colour. */
@Component({
  selector: 'app-cm-tip-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="cm-tip" role="note">
      <span class="cm-coin" aria-hidden="true">$</span>
      <div class="cm-txt">
        <b>{{ sender }}</b> tipped <b>{{ tip?.receiver }}</b>
        <div class="cm-time">{{ time }}</div>
      </div>
      <span class="cm-amt">{{ tip?.amount }}</span>
    </div>
  `,
  styles: [`
    .cm-tip { display: flex; align-items: center; gap: 12px; margin: 8px 0; padding: 10px 14px; border-radius: 10px;
      border: 1px dashed var(--cm-line); background: var(--cm-raise); }
    .cm-coin { width: 34px; height: 34px; flex: none; border-radius: 50%; display: grid; place-items: center;
      background: #f6c343; color: #3a2a00; font-weight: 700; }
    .cm-txt { min-width: 0; }
    .cm-time { font-size: 12px; color: var(--cm-muted); }
    .cm-amt { margin-left: auto; font-size: 18px; font-weight: 700; font-variant-numeric: tabular-nums; white-space: nowrap; }
  `],
})
export class CmTipCardComponent {
  @Input() tip: TipView | null = null;
  @Input() sender = '';
  @Input() time = '';
}
